import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ReplaySubject, Subject} from 'rxjs';
import {distinctUntilChanged, filter, takeUntil, tap} from "rxjs/operators";
import {MatAutocomplete, MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";


@Component({
    selector: 'app-autocomplete-input',
    templateUrl: './autocomplete-input.component.html'
})
export class AutocompleteInputComponent implements OnInit, OnDestroy {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    /** List of elements displayed on list */
    @Input() optionList: ReplaySubject<Map<string,any>> = new ReplaySubject<Map<string,any>>(1);
    /** Display for each element in the list */
    @Input() displayOptionElementProcessor: (value: any) => string;
    /** Display element in input component */
    @Input() displayElementProcessor: (value: any) => string;
    /** Value for input component */
    @Input() valueElementProcessor: (value: any) => string;
    @Input() autocompleteOff: boolean = false;

    /** Emits event with criteria typed to start search  */
    @Output() _onSearch = new EventEmitter<string>();
    /** Emits event with element when its selected on the list */
    @Output() _onSelection = new EventEmitter<any>();

    @ViewChild('auto') matAutocomplete: MatAutocomplete;

    /** indicate search operation is in progress */
    searching = false;

    /** Subject that emits when the component has been destroyed. */
    _onDestroy = new Subject<void>();

    mapElements: Map<string,any> = new Map<string, any>();

    ngOnInit() {
        this.inputControl.valueChanges
            .pipe(
                filter(() => !this.autocompleteOff),
                filter(search => !!search),
                distinctUntilChanged(),
                tap(() => this.searching = true),
                takeUntil(this._onDestroy))
            .subscribe(criteria => {
                    this.search(criteria);
                },
                () => {
                    this.searching = false;
                });
        this.optionList
            .subscribe(elements => {
                this.mapElements.clear();
                elements.forEach((value, key) => this.mapElements.set(key,value));
            });
    }


    private search(criteria) {
        if(criteria && criteria.length > 2) {
            this._onSearch.emit(criteria);
        }
    }

    get inputControl() {
        return this.parentFormGroup.get(this.parentFormControlName);
    }

    displayOptionElement(element: any):any {
        let value:string = this.displayOptionElementProcessor && this.displayOptionElementProcessor(element);
        return value ? value : element;
    }

    valueElement(element: any): string {
        let value:string = this.valueElementProcessor && this.valueElementProcessor(element);
        return value ? value : element;
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    changeSelection(event: MatAutocompleteSelectedEvent) {
        this.emitElementSelected(event.option.id);
    }

    emitElementSelected(id:string) {
        let element:any = this.mapElements.get(id);
        this._onSelection.emit(element);
    }
}
